module.exports = __webpack_public_path__ + "static/media/40s_male_actors_temp.a5b092ef.jpg";